import 'core-js/stable'; // eslint-disable-line import/no-unassigned-import
import 'regenerator-runtime/runtime'; // eslint-disable-line import/no-unassigned-import
import { ApolloProvider } from '@apollo/client';
import React, { useMemo } from 'react';
import { Provider } from 'react-redux';

import GlobalLoader from 'components/GlobalLoader';
import App from 'containers/App';
import OptimizelyWithAttributesProvider from 'contexts/OptimizelyWithAttributes';
import apolloClient from 'graphql/apollo';
import useCurrentUserDetails from 'hooks/useCurrentUserDetails';

import configureStore from './store';

const LifeWeb = () => {
  const { fetching, currentUserDetails } = useCurrentUserDetails();

  // This component is actually re-rendered on every route change due to being encompassed within
  // a BrowserRouter instance. To avoid re-instantiating the store on every route change, we're
  // declaring it only when the current user information is initially fetched
  const store = useMemo(() => {
    if (currentUserDetails) {
      return configureStore({
        activeUserUuid: currentUserDetails.uuid,
        activeLifeApplicationId: currentUserDetails.lifeApplicationId,
        lifeApplicationReferenceId: currentUserDetails.lifeApplicationReferenceId,
        hasEmail: !!currentUserDetails.email,
      });
    }
  }, [fetching, currentUserDetails]);

  if (fetching) {
    return <GlobalLoader />;
  }

  // If we have currentUserDetails, we're guaranteed to have a store based on the above `useMemo`
  // The `!store` condition here is just to make this extra type-safe
  if (!currentUserDetails || !store) {
    window.location.assign('/500');

    return null;
  }

  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <OptimizelyWithAttributesProvider uuid={currentUserDetails.uuid}>
          <App />
        </OptimizelyWithAttributesProvider>
      </Provider>
    </ApolloProvider>
  );
};

export default LifeWeb;
